/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IDraggableInfo } from "./DragAndDropTypes";
import { useDeepCompareMemo } from "use-deep-compare";
import * as attributes from "./dragAndDropAttributes";

export interface IDragAndDropPlaceholderProps {
	contextId: string;
	draggableInfo: IDraggableInfo;
}

export const DragAndDropPlaceholder: React.FC<IDragAndDropPlaceholderProps> = ({
	draggableInfo,
	contextId
}) => {
	const style = useDeepCompareMemo<React.CSSProperties>(
		() => ({
			display: draggableInfo.display,
			boxSizing: "border-box",
			width: draggableInfo.box.borderBox.width,
			height: draggableInfo.box.borderBox.height,
			// creating marginBox
			marginTop: draggableInfo.box.margin.top,
			marginRight: draggableInfo.box.margin.right,
			marginBottom: draggableInfo.box.margin.bottom,
			marginLeft: draggableInfo.box.margin.left,
			flexShrink: 0,
			flexGrow: 0,
			pointerEvents: "none"
		}),
		[ draggableInfo ]
	);

	return React.createElement(draggableInfo.tagName, {
		style,
		[attributes.placeholder.contextId]: contextId
	});
};
